import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import DateRangePicker from '../dateRangePicker/DateRangePicker';
import Dropdown from '../dropdown/dropdown';
import styles from './transactions.module.scss';

export interface TransactionFiltersProps {
  activeTab: 'Deposit' | 'Withdrawal' | 'Tip';
  filters: {
    status: string;
    type: string;
    minAmount: string;
    maxAmount: string;
  };
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  fromDate: Dayjs | null;
  setFromDate: (date: Dayjs | null) => void;
  toDate: Dayjs | null;
  setToDate: (date: Dayjs | null) => void;
  handleFilterChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const TransactionFilters: React.FC<TransactionFiltersProps> = ({
  activeTab,
  filters,
  setFilters,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleFilterChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.filterRow}>
      <div className={styles.filterItem}>
        <DateRangePicker
          fromDate={fromDate}
          toDate={toDate}
          onFromChange={(date) => setFromDate(date)}
          onToChange={(date) => setToDate(date)}
        />
      </div>
      <div className={styles.filterItem}>
        {activeTab === 'Tip' ? (
          <Dropdown
            prefix={t('transactions.filters.typePrefix', 'Type:')}
            options={[
              { value: '', label: t('transactions.filters.all', 'All') },
              { value: 'sent', label: t('transactions.types.sent', 'Sent') },
              { value: 'received', label: t('transactions.types.received', 'Received') },
            ]}
            value={filters.type}
            onChange={(value) => setFilters((prev: any) => ({ ...prev, type: value, page: 1 }))}
            width="100%"
          />
        ) : (
          <Dropdown
            prefix={t('transactions.filters.statusPrefix', 'Status:')}
            options={[
              { value: '', label: t('transactions.filters.all', 'All') },
              { value: 'pending', label: t('transactions.statuses.pending', 'Pending') },
              { value: 'completed', label: t('transactions.statuses.completed', 'Completed') },
              { value: 'cancelled', label: t('transactions.statuses.cancelled', 'Cancelled') },
            ]}
            value={filters.status}
            onChange={(value) => setFilters((prev: any) => ({ ...prev, status: value, page: 1 }))}
            width="100%"
          />
        )}
      </div>
      {activeTab !== 'Tip' && (
        <>
          <div className={`${styles.filterItem} ${styles.amountItem}`}>
            <input
              name="minAmount"
              placeholder={t('transactions.filters.minAmount', 'Min Amount')}
              value={filters.minAmount}
              onChange={handleFilterChange}
            />
          </div>
          <div className={`${styles.filterItem} ${styles.amountItem}`}>
            <input
              name="maxAmount"
              placeholder={t('transactions.filters.maxAmount', 'Max Amount')}
              value={filters.maxAmount}
              onChange={handleFilterChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default TransactionFilters;
